import React from 'react';
interface WelcomeSectionProps {
  businessName: string;
  progress: number;
}
export const WelcomeSection = ({
  businessName,
  progress
}: WelcomeSectionProps) => {
  return <section className="bg-white rounded-xl shadow-sm p-6" data-id="element-114">
      <div className="space-y-4" data-id="element-115">
        <div data-id="element-116">
          <h1 className="text-2xl font-semibold text-gray-800" data-id="element-117">
            Welcome back, {businessName}
          </h1>
          <p className="text-gray-600 mt-1" data-id="element-118">
            You're {progress}% compliant with DPDP Act
          </p>
        </div>
        {/* Progress bar */}
        <div className="space-y-2" data-id="element-119">
          <div className="h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-120">
            <div className="h-full bg-indigo-600 transition-all duration-500 ease-out" style={{
            width: `${progress}%`
          }} data-id="element-121" />
          </div>
          <div className="flex justify-between text-sm text-gray-500" data-id="element-122">
            <span data-id="element-123">Progress</span>
            <span data-id="element-124">{progress}%</span>
          </div>
        </div>
      </div>
    </section>;
};